"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerWrapper = exports.SpinnerSvg = exports.Logo = exports.Loader = exports.Container = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const Container = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  width: 100%;
`;
exports.Container = Container;
const fillAnimation = (0, styled_components_1.keyframes) `
  0% {
    fill: ${colors_1.theme};
  }
  50% {
    fill: transparent;
  }
  100% {
    fill: ${colors_1.theme};
  }
`;
const Loader = styled_components_1.default.div `
  height: fit-content;
  width: ${(props) => props.width};
  padding: 0px;
  display: flex;
`;
exports.Loader = Loader;
const Logo = styled_components_1.default.svg `
  width: 100%;
  height: 100%;

  path {
    fill: ${colors_1.theme};
    animation: ${fillAnimation} 2s infinite alternate;
  }
`;
exports.Logo = Logo;
const SpinnerWrapper = styled_components_1.default.div `
  position: absolute;
  right: 1rem;
  display: inline-block;
  width: 2rem;
  height: 2rem;
`;
exports.SpinnerWrapper = SpinnerWrapper;
const SpinnerSvg = styled_components_1.default.svg `
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
exports.SpinnerSvg = SpinnerSvg;
